import { QueryParametersState } from "@idw-types/state";
import { QueryParametersActions, QueryParametersActionTypes } from "../actions/query-parameters-actions";


export const initialQueryParametersState: QueryParametersState = {
    token: null,
    environment: null,
    apiUrl: null,
	language: null,
    initialized: false
};

export const queryParametersReducer = (
	state: QueryParametersState = initialQueryParametersState,
	action: QueryParametersActions
) => {
	switch (action.type) {
		case QueryParametersActionTypes.SET_QUERY_PARAMETERS:
			return {
				...state,
				...action.payload.queryParameters
			};
		default:
			return state;
	}
};
